import { render } from "./Certificate2.vue?vue&type=template&id=771941c3&scoped=true"
import script from "./Certificate2.vue?vue&type=script&lang=js"
export * from "./Certificate2.vue?vue&type=script&lang=js"

import "./Certificate2.vue?vue&type=style&index=0&id=771941c3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\oaromasodun\\Desktop\\MarinePortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771941c3"]])

export default __exports__